function normalize(value) {
    return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

export function followupNotificationKey(fu) {
    const leadId = fu?.lead?.id || fu?.lead_id || "";
    const stage = normalize(fu?.stage_name || fu?.type || "");
    return [leadId, stage].join("::");
}

export function uniqueFollowups(list) {
    const seen = new Map();
    for (const fu of list || []) {
        const key = followupNotificationKey(fu);
        if (!seen.has(key)) {
            seen.set(key, fu);
            continue;
        }
        const prev = seen.get(key);
        const prevTime = new Date(prev?.date || 0).getTime();
        const nextTime = new Date(fu?.date || 0).getTime();
        // Keep the older overdue item, or the soonest upcoming item, for stable display.
        if (Number.isFinite(nextTime) && Number.isFinite(prevTime) && nextTime < prevTime) {
            seen.set(key, fu);
        }
    }
    return [...seen.values()];
}

